import { render, staticRenderFns } from "./RegiaoForm.vue?vue&type=template&id=4b62fdc9&lang=html"
import script from "./RegiaoForm.vue?vue&type=script&lang=js"
export * from "./RegiaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports